import axios from "axios";
import { REACT_APP_BASE_PATH } from "../config/runtimeConfig";
import type { DashboardExecuteResponse } from "../types/dashboard";
import type { PublicShareMeta } from "../types/share";
import type { WidgetExecuteRequest } from "../types/widget";

const publicApi = axios.create({
  baseURL: REACT_APP_BASE_PATH,
  headers: { "Content-Type": "application/json" },
});

export const publicShareService = {
  getMeta: async (token: string) => {
    const res = await publicApi.get<PublicShareMeta>(`/public/share/${token}`);
    return res.data;
  },

  auth: async (token: string, password: string) => {
    const res = await publicApi.post(`/public/share/${token}/auth`, { password });
    return res.data;
  },

  execute: async (token: string, body: WidgetExecuteRequest, password?: string) => {
    const params = password ? { password } : undefined;
    const res = await publicApi.post<DashboardExecuteResponse>(
      `/public/share/${token}/execute`,
      body,
      { params }
    );
    return res.data;
  },
};
